export default __webpack_public_path__ + "static/media/mlqu-min.d6f82aac.png";